/*
  Barra de posición de los carruseles mobile.

  Cada carrusel marcado con data-eq-carousel busca su barra hermana
  ([data-eq-carousel-bar] con el mismo valor) y le publica dos variables:
  --eq-w (proporción visible) y --eq-p (progreso de 0 a 1). El CSS hace el
  resto; aquí no se toca ningún estilo.
*/
(function () {
  'use strict';

  function pinta(carrusel, barra) {
    var visible = carrusel.clientWidth;
    var total = carrusel.scrollWidth;
    var recorrido = total - visible;

    if (recorrido <= 1) {
      barra.hidden = true;
      return;
    }

    barra.hidden = false;
    barra.style.setProperty('--eq-w', ((visible / total) * 100).toFixed(2) + '%');
    barra.style.setProperty('--eq-p', (carrusel.scrollLeft / recorrido).toFixed(4));
  }

  function conecta(carrusel) {
    if (carrusel.dataset.eqCarouselReady === 'true') return;

    var id = carrusel.getAttribute('data-eq-carousel');
    var barra = document.querySelector('[data-eq-carousel-bar="' + id + '"]');
    if (!barra) return;

    carrusel.dataset.eqCarouselReady = 'true';

    var pendiente = false;
    var actualiza = function () {
      if (pendiente) return;
      pendiente = true;
      window.requestAnimationFrame(function () {
        pendiente = false;
        pinta(carrusel, barra);
      });
    };

    carrusel.addEventListener('scroll', actualiza, { passive: true });
    window.addEventListener('resize', actualiza);

    if (typeof ResizeObserver === 'function') {
      new ResizeObserver(actualiza).observe(carrusel);
    }

    pinta(carrusel, barra);
  }

  // Buscador del nivel 2 del menú mobile: filtra la lista A–Z ya renderizada.
  // Si esto no llegara a ejecutarse la lista sigue completa y navegable.
  function conectaBuscador(input) {
    if (input.dataset.eqSearchReady === 'true') return;
    input.dataset.eqSearchReady = 'true';

    var id = input.getAttribute('data-eq-mmm-search');
    var lista = document.querySelector('[data-eq-mmm-list="' + id + '"]');
    var vacio = document.querySelector('[data-eq-mmm-empty="' + id + '"]');
    if (!lista) return;

    var filas = Array.prototype.slice.call(lista.children);

    input.addEventListener('input', function () {
      var q = input.value.trim().toLowerCase();
      var visibles = 0;

      filas.forEach(function (fila) {
        var nombre = fila.getAttribute('data-eq-mmm-name') || '';
        var pasa = q === '' || nombre.indexOf(q) !== -1;
        fila.hidden = !pasa;
        if (pasa) visibles++;
      });

      if (vacio) vacio.hidden = visibles !== 0;
    });
  }

  function arranca() {
    document.querySelectorAll('[data-eq-carousel]').forEach(conecta);
    document.querySelectorAll('[data-eq-mmm-search]').forEach(conectaBuscador);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arranca);
  } else {
    arranca();
  }

  // Las secciones se vuelven a montar al editarlas en el Theme Editor.
  document.addEventListener('shopify:section:load', arranca);
})();
